export var COOKIE_LANGUAGE = 'nf_lang';
export var baseUrl = 'https://www.arcblock.io';
export var supportURL = 'mailto:support@arcblock.io';